import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { Modal, Button, Form, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Select from 'react-select'
import { clearCSVAuth } from '../../../redux/actions/authorization'
import { clearCSVClaims } from '../../../redux/actions/claims'
import './index.css'

interface Props {
  disableButton: boolean;
  providerOptions: any;
  selectedProvider: any;
  show: boolean;
  onClose: () => void;
  onChangeProviderData: (selected: any) => void;
  onClickSelect: () => void;
}

const SwitchFacilityModal: FC<Props> = ({ disableButton, providerOptions, selectedProvider, show, onClose, onChangeProviderData, onClickSelect }: Props) => {
  const dispatch = useDispatch()

  const handleSelect = () => {
    onClickSelect()
    dispatch(clearCSVAuth('LOCATION'))
    dispatch(clearCSVClaims('LOCATION'))
  }

  return (
    <Modal size="lg" show={show} onHide={onClose}>
      <Modal.Header closeButton id="switch-facility-header">
        <FontAwesomeIcon icon={['fas', 'user-circle']} size="lg" className="switch-facility-header-icon" />
        <Modal.Title id="switch-facility-header-title">Switch Facility</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="switch-facility-body">
            <Form.Group  as={Col} lg={12} md={12} sm={12} xs={12}>
              <Form.Label>Facility</Form.Label>
              <Select
                placeholder="Choose a Facility"
                options={providerOptions}
                value={selectedProvider}
                isClearable
                onChange={onChangeProviderData}
              />
            </Form.Group>
          </div>
          <div className="switch-facility-btn-grp">
            <Button variant="secondary" id="switch-facility-cancel-btn" onClick={onClose}>
							Cancel
            </Button>
            <Button id="switch-facility-add-btn" disabled={disableButton} onClick={handleSelect}>
							Select Facility
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default SwitchFacilityModal